import {
  getAllCustomers,
  getUnitTypes,
  getTree,
  associateUnit,
  unassociateUnit,
  getCustomerById,
  getBusinessUnitById,
  updateBusinessUnitById,
  addUnitType,
  editUnitType,
  addBusinessUnit,
  getUnassociatedClients,
} from '@/api/divy-businessUnits';
const nest = (items, id = 0, link = 'parent_id') =>
  items
    .filter((item) => item[link] === id)
    .map((item) => ({
      ...item,
      children: nest(items, item.key),
    }));
const businessUnits = {
  namespaced: true,
  state: () => ({ UnitTypes: [], Customer: null, BusinessUnit: null, Tree: [], TreeData: [], Status: '', OpenModal: '', Clients: [] }),
  getters: {},
  actions: {
    updateOpenModal({ commit }, payload) {
      commit('SET_OPEN_MODAL', payload);
    },
    getCustomers({ commit }, payload) {
      return getAllCustomers(payload);
    },
    getClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUnassociatedClients(payload)
          .then((Clients) => {
            commit('SET_CLIENTS', Clients);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    getUnitTypes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUnitTypes(payload)
          .then((UnitTypes) => {
            commit('SET_UNIT_TYPES', UnitTypes);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    updateBusinessUnitById({ commit }, payload) {
      commit('SET_STATUS', 'saving');
      return new Promise((resolve, reject) => {
        updateBusinessUnitById(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    unassociateUnit({ commit }, payload) {
      commit('SET_STATUS', 'saving');
      return new Promise((resolve, reject) => {
        unassociateUnit(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    getCustomer({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getCustomerById(payload)
          .then((Customer) => {
            commit('SET_CUSTOMER', Customer);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    getBusinessUnit({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getBusinessUnitById(payload)
          .then((BusinessUnit) => {
            commit('SET_BUISNESS_UNIT', BusinessUnit);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    getTree({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getTree(payload)
          .then((Tree) => {
            Tree = Tree?.map(({ name, id, ...props }) => ({ title: name, key: id, ...props })) ?? [];
            commit('SET_TREE', Tree);
            resolve(Tree);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    addUnitType({ commit }, payload) {
      commit('SET_STATUS', 'updatingUnitType');
      return new Promise((resolve, reject) => {
        addUnitType(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    editUnitType({ commit }, payload) {
      commit('SET_STATUS', 'updatingUnitType');
      return new Promise((resolve, reject) => {
        editUnitType(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    addBusinessUnit({ commit }, payload) {
      commit('SET_STATUS', 'addingUnit');
      return new Promise((resolve, reject) => {
        addBusinessUnit(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    associateUnit({ commit }, payload) {
      commit('SET_STATUS', 'addingUnit');
      return new Promise((resolve, reject) => {
        associateUnit(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
  },

  mutations: {
    SET_CLIENTS: (state, Clients) => {
      state.Clients = Clients?.length > 0 ? Clients : [];
    },
    SET_UNIT_TYPES: (state, UnitTypes) => {
      state.UnitTypes = UnitTypes?.length > 0 ? UnitTypes : [];
    },
    SET_BUISNESS_UNIT: (state, BusinessUnit) => {
      state.BusinessUnit = BusinessUnit;
    },
    SET_CUSTOMER: (state, Customer) => {
      state.Customer = Customer;
    },
    SET_TREE: (state, Tree) => {
      state.Tree = nest(Tree);
      state.TreeData = Tree;
    },
    SET_STATUS: (state, Status) => {
      state.Status = Status;
    },
    SET_OPEN_MODAL: (state, OpenModal) => (state.OpenModal = OpenModal),
  },
};

export default businessUnits;
